import { FileText } from 'lucide-react';
import { useParams } from 'react-router-dom';

import { ChunkDocViewer } from '../doc-viewer/chunk-doc-viewer';
import { useGetChunkV2 } from '@/api/queries/useGetChunkV2';
import { Drawer } from '@/new/components/drawers/drawer';

interface ChunkDrawerProps {
  chunkId: string | null;
  isOpen: boolean;
  onClose: () => void;
}

export function ChunkDrawer({ chunkId, isOpen, onClose }: ChunkDrawerProps) {
  const { matterId } = useParams();
  const { data: chunk } = useGetChunkV2(matterId, chunkId);

  return (
    <Drawer isOpen={isOpen} onClose={onClose} hideCloseButton={true}>
      <div className="flex h-full flex-col">
        {chunk && (
          <>
            {/* Document Name Bar */}
            <div className="border-b border-gray-300 bg-gray-50">
              <div className="flex items-center gap-3 px-4 py-2">
                <div className="flex h-9 items-center gap-2 rounded-md border border-gray-200 bg-white px-3">
                  <div className="flex items-center gap-1.5">
                    <FileText className="h-3.5 w-3.5 text-blue-600" />
                    <span className="text-xs font-medium text-gray-700">Document:</span>
                  </div>
                  <div className="flex h-6 items-center">
                    <span className="max-w-52 truncate text-xs text-gray-700">
                      {chunk.doc?.file?.name || 'Document'}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Document Viewer Section */}
            <div className="flex-1 overflow-hidden">
              <ChunkDocViewer
                docId={chunk.docId}
                chunkId={chunk.id}
                boundingBoxes={chunk.boundingBoxes}
                onClose={onClose}
              />
            </div>
          </>
        )}
      </div>
    </Drawer>
  );
}
